// Zod runs every failing check on a field, not just the first, so chaining
// `.min(1, required)` with `.regex(pattern, invalid)` shows BOTH messages on an
// empty value. Widening the pattern to also match blank defers "is it present"
// entirely to `.min()`, so only one message ever surfaces at a time. `.refine`
// would be the usual fix but dead-locks the shared Form's legacy zod adapter.
export function optionalPattern(pattern: RegExp): RegExp {
  return new RegExp(`^$|${pattern.source}`, pattern.flags);
}
